// https://github.com/binaryluke/Minesweeper#readme

export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = false;
    public static readonly DEBUG_MODE = false;
    public static readonly VERBOSE = false;

    public static readonly GAME_WIDTH = 768;
    public static readonly GAME_HEIGHT = 1024;

    public static readonly DIFFICULTY_EASY = "beginner";
    public static readonly DIFFICULTY_MEDIUM = "intermediate";
    public static readonly DIFFICULTY_HARD = "expert";

    public static readonly BOARD_STATE_PRISTINE = 0;
    public static readonly BOARD_STATE_IN_PROGRESS = 1;
    public static readonly BOARD_STATE_LOST = 2;
    public static readonly BOARD_STATE_WON = 3;

    public static readonly BOARD_SIZE_BEGINNER = { r: 9, c: 9 }; // = 81
    public static readonly BOARD_SIZE_INTERMEDIATE = { r: 12, c: 10}; // = 120
    public static readonly BOARD_SIZE_EXPERT = { r: 14, c: 12 }; // = 168

    public static readonly BOARD_SCALE_BEGINNER = 1.15;
    public static readonly BOARD_SCALE_INTERMEDIATE = 1.025;
    public static readonly BOARD_SCALE_EXPERT = .8725;

    public static readonly CELL_SIZE = 72;

    public static readonly BITMAP_SIZE = 64;

    public static readonly BLACK_SQUARE = "black-square";
    public static readonly WHITE_SQUARE = "white-square";
    public static readonly RED_SQUARE = "red-square";
    public static readonly ORANGE_SQUARE = "orange-square";
    public static readonly YELLOW_SQUARE = "yellow-square";
    public static readonly GREEN_SQUARE = "green-square";
    public static readonly BLUE_SQUARE = "blue-square";

    public static readonly SAVED_GAME_DATA_KEY = "minesweeper-classic-data";
}
